import axios from 'axios';
import { Product } from 'src/models/product.model';
import { getProductInformation } from 'src/services/product-service';
// BESPOKE THERM-46: Added getCurrencySign
import { getCurrencySign } from 'src/utilities/helpers';
// END BESPOKE THERM-46


const state = {
  loadingQuotations: true,
  quotationsBaseAddress: "/Bespoke/QuotationWebmethods.aspx/",
  quotations: [],
  selectedQuote: null,
  selectedQuoteId: null,
  currentQuoteVatCode: '',
  isShowSelectQuotesTool: false,
  queingQuoteProduct: false,
  quoteProductInQue: null,
  defaultVatCode: null,
  currencySign: ""
};

const getters = {
  defaultVatCode(state) {
    return state.defaultVatCode;
  },
  loadingQuotations(state) {
    return state.loadingQuotations;
  },
  quotations(state) {
    return state.quotations
  },
  quotationsBaseAddress(state) {
    return state.quotationsBaseAddress;
  },
  selectedQuoteId(state) {    
    return state.selectedQuoteId;
  },
  selectedQuote(state) {
    return state.selectedQuote;
  },
  isShowSelectQuotesTool(state) {
    return state.isShowSelectQuotesTool;
  },
  quoteProductInQue(state) {
    return state.quoteProductInQue;
  },
  queueingQuoteProduct(state) {
    return state.queingQuoteProduct;
  },
  currencySign(state) {
    return state.currencySign;
  }
};

const actions = {
  init ({ commit, dispatch }) {
    // BESPOKE THERM-41
    // Get currency sign first
    getCurrencySign().then(res => {
      if (res) {
        commit('setCurrencySign', res);
        dispatch('getQuotations');
      }
    });
    // END BESPOKE THERM-41
    // Get quotations
  },
  getVatCodes({ state, getters }) {
    return new Promise((resolve, reject) => {       
      axios.post(getters.quotationsBaseAddress + "GetAvailableVatCodes", { })
        .then(res => {
          if (res.data.d.IsSuccess) {
            state.defaultVatCode = res.data.d.Vat[0].Code;
            resolve();
          } else {
            reject();
          }
        });
    });
  },
  createQuote({ state, rootGetters, getters, dispatch }) {
    dispatch('getVatCodes').then(_ => {
      if (getters.defaultVatCode) {
        axios.post( getters.quotationsBaseAddress + 'CreateQuotation', { debtorId: rootGetters.customerUserId, vatCode: getters.defaultVatCode })
          .then(res => {
            var response = res.data.d;
            if (response.IsSuccess) {

              var dateString = response.QuoteDate;
              let parts = dateString.split('-');
              let formattedDateString = `${parts[1]}/${parts[0]}/${parts[2]}`;

              var newQuote = {
                id: response.RecId,
                date: new Date(formattedDateString).format("dd-MM-yyyy"),
                isActive: false,
                name: '',
                subtotalExclVat: 0,
                vatCode: getters.defaultVatCode
              };
              state.quotations.unshift(newQuote);
            } else {  
              alert('ERROR');
            }
          }); 
      }      
    });
  },
  getQuotations({ getters, rootGetters, commit, dispatch }) {    
    commit('setLoadingQuotations', true);
    axios.post(getters.quotationsBaseAddress + "GetQuotations", { debtorId: rootGetters.customerUserId, recId: '' })
      .then(res => {
        var lines = res.data.d.map(x => {
          var dateString = x.QuoteDate;
          let parts = dateString.split('-');
          let formattedDateString = `${parts[1]}/${parts[0]}/${parts[2]}`;

          var expDateString = x.QuoteExpirationDate;
          let expParts = expDateString.split('-');
          let formattedExpDateString = `${expParts[1]}/${expParts[0]}/${expParts[2]}`;

          return {
            id: x.RecId,
            date: new Date(formattedDateString).format("dd-MM-yyyy"),
            expirationDate: new Date(formattedExpDateString).format("dd-MM-yyyy"),
            name: x.InvAddress.Name,
            subtotalExclVat: x.TotalExcl,
            isActive: false,
            vatCode: x.VatCode
          }
        });

        lines = lines.sort((x, y) => parseInt(y.id) - parseInt(x.id));

        commit('setQuotations', lines);
        commit('setLoadingQuotations', false);
        
        // See if there is an active quotations id in local storage
        var quoteIdStoredInSession = window.localStorage.getItem('selectedQuoteId');    
        if (quoteIdStoredInSession !== null) {      
          return new Promise((resolve, reject) => {            
            dispatch('setSelectedQuote', { quoteId: quoteIdStoredInSession, isActive: true });
            resolve();
          });
        }

      });
  },
  copyQuotation({ getters }, { debtorId, quotationId }) {
    return new Promise((resolve, reject) => {  
      axios.post(getters.quotationsBaseAddress + "CopyQuotation", { debtorId: debtorId, existingQuoteId: quotationId }).then(res => {
        var response = res.data.d; 
        if (response.IsSuccess) {
          resolve(response.NewQuoteId);
        } else {
          var errorMessage = window.vue.translations.label.label_err_add_prod_quote;          
          window.updateErrorMessage(errorMessage);
          reject();
        }
      })

    });
  },
  setSelectedQuote({ commit, getters }, { quoteId, isActive }) {
    var selectedQuoteIndex = getters.quotations.findIndex(x => x.id === quoteId);
    if (selectedQuoteIndex > -1) {
      commit('setSelectedQuote', {quoteId, isActive});
    }
  },
  addProductToQuotation({getters, commit}, quotationProduct) {
    return new Promise((resolve, reject) => {      

      var payload = {
        hdrId: getters.selectedQuote.id,
        prodCode: quotationProduct.productId, 
        prodDesc: quotationProduct.productDescription,
        quoteQty: quotationProduct.quantity,
        vatCode: getters.selectedQuote.vatCode,
        prodPrice: quotationProduct.productPrice,
        rowAmt: quotationProduct.productPrice * quotationProduct.quantity,
        rowOrd: getters.quotations.length + 1,
        comment: quotationProduct.comment != undefined ? quotationProduct.comment : '',
        isCustomProduct: false
      };
      
      axios.post(getters.quotationsBaseAddress + "CreateQuotationLine", payload).then(res => {
        var response = res.data.d; 
        if (response.IsSuccess) {       
          quotationProduct.rowOrder = payload.rowOrd;
          quotationProduct.recId = response.RecId;
          
          commit('setTotals', { totalExcl: response.Totals.TotalExcl, recId: getters.selectedQuote.id });

          var succesMessage = window.vue.translations.label.label_prod_added_to_quote.replace('[1]', payload.hdrId);
          window.updateOrderMessage(succesMessage);
          resolve();
        } else {
          var errorMessage = window.vue.translations.label.label_err_add_prod_quote;          
          window.updateErrorMessage(errorMessage);
        }
      })

    });    
  },
  showSelectQuotesTool({commit}, show) {
    commit('setShowSelectQuotesTool', show);
  },
  promptUserForQuote({commit}, quoteProduct) {
    commit('setShowSelectQuotesTool', true);
    commit('setQuoteProductInQue', quoteProduct);
    commit('setQueingQuoteProduct', true);
  },
  cancelPromptUserForQuote({ commit }) {
    commit('setShowSelectQuotesTool', false);
    commit('setQuoteProductInQue', null);
    commit('setQueingQuoteProduct', false);
  },
  addQueuedProductToQuoteList({ getters, commit, dispatch }, quoteId) {
    commit('setSelectedQuote', {quoteId: quoteId, isActive: true });

    var quotationProduct = {
      productId: getters.quoteProductInQue.productId, 
      productDescription: getters.quoteProductInQue.productDescription,
      quantity: getters.quoteProductInQue.quantity,
      productPrice: getters.quoteProductInQue.productPrice
    };
    dispatch('cancelPromptUserForQuote');
    dispatch('addProductToQuotation', quotationProduct);
  },  
  saveInvoiceBusinessName({ getters, commit },{ quoteRecId, businessName }) {
    return new Promise((resolve, reject) => {       
      var payload = { quoteRecId: quoteRecId, businessName: businessName };
      axios.post(getters.quotationsBaseAddress + "UpdateInvoiceBusinessName", payload)
        .then(res => {
          if (res.data.d) {
            commit('updateBusinessName', { quoteId: quoteRecId, businessName: businessName })
            resolve();
          } else {
            var errorMessage = window.vue.translations.label.label_err_add_prod_quote;          
            window.updateErrorMessage(errorMessage);
            reject();
          }
        });
    });
  }
};

const mutations = {
  setCurrencySign(state, currencySign) {
    state.currencySign = currencySign;
  },
  setQuotations (state, quotations) {
    state.quotations = quotations;
  },
  setLoadingQuotations(state, loading) {
    state.loadingQuotations = loading;
  },
  setSelectedQuote(state, { quoteId, isActive }) {
    state.quotations.forEach(x => {
      x.isActive = false;

      if (x.id === quoteId) {
        x.isActive = isActive;
      }
    });

    var indexSelectedQuote = state.quotations.findIndex(x => x.isActive);

    if (indexSelectedQuote > -1) {
      var quote = {...state.quotations[indexSelectedQuote]};
      state.selectedQuote = quote;
      state.selectedQuoteId = quote.id;
      window.localStorage.setItem('selectedQuoteId', quote.id);
    } else {
      state.selectedQuote = null;
      state.selectedQuoteId = null;
      window.localStorage.removeItem('selectedQuoteId');
    }
  },
  setShowSelectQuotesTool(state, show) {
    state.isShowSelectQuotesTool = show;
    state.isShowSelectQuotesTool = show;
  },
  setQueingQuoteProduct(state, inQue) {
    state.queingQuoteProduct = inQue;
  },
  setQuoteProductInQue(state, quoteProduct) {
    state.quoteProductInQue = quoteProduct;
  },
  setTotals(state, { totalExcl, recId }) {
    var index = state.quotations.findIndex(x => x.id == recId);
    state.quotations[index].subtotalExclVat = totalExcl;
  },
  updateBusinessName(state, {quoteId, businessName}) {
    var quoteIndex = state.quotations.findIndex(x => x.id === quoteId);
    state.quotations[quoteIndex].name = businessName;
  }
};

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};